module.exports = __webpack_public_path__ + "img/floating_unit.e2cd492c.svg";